export default "__VITE_ASSET__ByvyIEbj__"